<template>
    <r-e-dialog title="开锁记录" :visible.sync="dialogVisible" top="5vh" width="700px" :show-footer="false">
        <div class="flex" style="background-color: #EFF9FF;height: 40px;justify-content: space-between;align-items: center;color: #333333;font-size: 15px;">
            <div style="margin-left: 20px">
                房间号 : {{equipmentData.name}}
<!--              房间号12 ： {{equipmentData.name}}-->
            </div>
            <div style="margin-right: 20px">
                门锁号: {{equipmentData.lockId}}
            </div>
        </div>
        <div>
            <!-- <el-select size="small" v-model="type" placeholder="请选择">
                <el-option label="全部" value=""/>
                <el-option label="密码开门" value="4"/>
               <el-option label="钥匙开门" value="EVENT_KEY_ACTION"/>
               <el-option label="临时密码开门" value="EVENT_TOKEN_ACTION"/>
               <el-option label="内把手开门" value="EVENT_INNER_HANDLE_ACTION"/>
               <el-option label="关门" value="EVENT_CLOSE"/>
            </el-select> -->
            <el-date-picker v-model="dateArr" ref="dateArrRef" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                            size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
            <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset" size="small">重置</el-button>
        </div>
        <r-e-table ref="communityTableRef" :columns="tableColumnUnlockRecord"  :dataRequest="getFamilyList" :query="formSearch" :height="300">
            <template slot="empty">
                <el-empty/>
            </template>
        </r-e-table>
    </r-e-dialog>
</template>

<script>
    import {tableColumnUnlockRecord} from "@/views/property-management/door-management/data";
    import {openLocksLog} from "@/api/door-management"

    export default {
        name: "dialog-show-unlock-record",
        data() {
            return {
                dialogVisible: false,
                dataList: [],
                tableColumnUnlockRecord,
                type: '',
                uuid: '',
                dateArr: [],
                formSearch: {},
                iotTag: null,
            }
        },
        props: {
            equipmentData: {
                type: Object,
                default: () => ({})
            }
        },
        components: {},
        methods: {
            openDialog(data,iotTag) {
                console.log('iotTag',iotTag);
                this.iotTag = Number(iotTag);
                this.uuid = data;
                this.dialogVisible = true;
            },
            getFamilyList(params) {
                let {uuid} = this;
                params.type = this.type;
                if (this.dateArr && this.dateArr.length !== 0) {
                    let [startDate, endDate] = this.dateArr;
                    params.startDate = startDate;
                    params.endDate = endDate;
                }
              console.log(openLocksLog(uuid, params))
                return openLocksLog(uuid, params);
            },
            handleSearch() {
                this.$refs["communityTableRef"].pNumber = 1;
                this.$refs["communityTableRef"].getTableData();
            },
            handleReset(){
            this.$refs['dateArrRef'].hidePicker();
            this.dateArr = []
            this.handleSearch()
          },
        //     pretreat(list) {
        //     if (this.iotTag === 1) {
        //       list = list.map(item => {
        //         const {updateTime,createTime, logAlert} = item;
        //         console.log('updateTime',updateTime,logAlert,createTime);
        //         const lockDate = createTime 
        //         console.log('time',lockDate);
        //         return {...item, lockDate, logAlert}
        //       });
        //     }
        //     return list;
        //   }
        },
    }
</script>

<style scoped>

</style>